
export function classes( ...classes ) {
    return classes.join( ' ' );
}